import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input } from "@angular/core";
import { CONFIRM_MODAL_TITLE, DISMISS_MODAL_CANCEL, DISMISS_MODAL_MESSAGE, DISMISS_MODAL_OK } from "@helpers/constants";
import { ModalPreset } from "@modules/+new/shared/universal-modal/entities/modal-preset.interface";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";

export interface ConfirmDialogData {
	title?: string;
	message: string;
	okLabel?: string;
	cancelLabel?: string;
}

@Component({
	template: `
		<div class="main-container" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
			<!-- Title -->
			@if (!!texts.title) {
				<h4 class="font-size-24 no-hyphens text-left">{{ texts.title | translate }}</h4>
			}
			<!-- Message -->
			<div class="message">{{ texts.message | translate }}</div>
			<!-- Buttons -->
			<div class="text-right">
				<button class="btn btn-link mr-10" (click)="cancel()">{{ texts.cancelLabel | translate }}</button>
				<button class="btn btn-primary" (click)="accept()">{{ texts.okLabel | translate }}</button>
			</div>
		</div>
	`,
	styleUrls: ["./confirm.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ConfirmComponent implements ModalPreset<ConfirmDialogData>, AfterViewInit {
	constructor(
		@Inject(UniversalModalService) private service,
		private cdr: ChangeDetectorRef
	) {}

	public ngAfterViewInit(): void {
		this.cdr.markForCheck();
	}

	@Input() public set data(s: ConfirmDialogData) {
		this.texts = { ...this.texts, ...s };
	}
	public texts: ConfirmDialogData = {
		title: CONFIRM_MODAL_TITLE,
		cancelLabel: DISMISS_MODAL_CANCEL,
		okLabel: DISMISS_MODAL_OK,
		message: DISMISS_MODAL_MESSAGE
	};

	public cancel = (): void => this.service.rewind();
	public accept = (): void => this.service.close(ModalCloseReason.close);
}
